import React from 'react';
import { PolarArea } from 'react-chartjs-2';
import { FaInfoCircle } from 'react-icons/fa';
import '../stylesheets/components/Charts.css';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import PropTypes from 'prop-types';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

const PolarAreaChart = ({
  title = 'Polar Area Chart Title',
  value,
  subtitle = 'Text or Description',
  data = [],
  labels = [],
  legendLabels = [],
  legendColors = [],
  infoTooltip = '',
}) => {
  const chartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: legendColors,
        borderWidth: 2, // Make sure border is visible
        borderColor: '#fff', // White border for separation
        hoverBorderWidth: 2,
        hoverBorderColor: '#fff',
        // Remove shadow if present
      },
    ],
  };
  const options = {
    plugins: {
      datalabels: {
        display: false
      },
      legend: { display: false },
      tooltip: { enabled: true },
    },
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      arc: {
        borderWidth: 2, // Draw a border line on each arc
        borderColor: '#fff', // White border for separation
      },
    },
    scales: {
      r: {
        angleLines: { color: '#bbb', z: 10 }, // darker and above arcs
        grid: { color: '#bbb', z: 10 }, // darker and above arcs
        pointLabels: { font: { size: 12 }, color: '#888', z: 10 },
        ticks: { color: '#888', font: { size: 12 }, stepSize: value >= 10 ? 10 : 1, backdropColor: 'transparent', z: 10 },
        min: 0,
        max: value >= 10 ? Math.ceil(value / 10) * 10 : value,
      },
    },
  };

  return (
    <div className="chart-card-container">
      <div className="chart-card__title-row">
        <span className="chart-card__title">{title}</span>
        <span className="chart-card__icon" title={infoTooltip}>
          <FaInfoCircle size={16} color="#B0B0B0" />
        </span>
      </div>
      {typeof value !== 'undefined' && (
        <div className="chart-card__value">{value}</div>
      )}
      <div className="chart-card__subtitle">{subtitle}</div>
      <hr className="chart-card__divider" />
      <div className="chart-card__body--horizontal">
        <div className="polar-area-chart-wrap">
          <PolarArea data={chartData} options={options} />
        </div>
        <div className="chart-card__legend-area">
          {legendLabels.map((label, idx) => (
            <div className="custom-legend-item" key={label}>
              <span
                className="custom-legend-color"
                style={{ backgroundColor: legendColors[idx] }}
              />
              <span className="custom-legend-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

PolarAreaChart.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.array,
  labels: PropTypes.array,
  legendLabels: PropTypes.array,
  legendColors: PropTypes.array,
  infoTooltip: PropTypes.string,
};

export default PolarAreaChart;
